/**
 * FullStory v2 API utilities.
 *
 * FullStory is conditionally loaded via the VITE_USE_FULLSTORY env var.
 * All calls are guarded behind a window.FS existence check so they
 * are safe to call in environments where FullStory is not loaded.
 */

/**
 * Identifies the current user in FullStory with their user ID and email.
 * @param uid - The user's numeric ID (as a string)
 * @param email - The user's email address
 */
export function identifyFullStoryUser(uid: string, email: string): void {
  if (!window.FS) return;

  window.FS('setIdentity', {
    uid,
    properties: { email },
  });
}

/**
 * Anonymizes the current FullStory session, releasing the user's identity.
 */
export function anonymizeFullStoryUser(): void {
  if (!window.FS) return;

  window.FS('setIdentity', { anonymous: true });
}

/**
 * Sets the current policy ID as a FullStory page property.
 * @param policyId - The policy ID from the route params
 */
export function setFullStoryPolicyContext(policyId: string): void {
  if (!window.FS) return;

  window.FS('setProperties', {
    type: 'page',
    properties: { policyId },
  });
}
